<div class="notif-wrapper" [class.show]="show">
  <div class="icon">
    <img src="assets\general\tick-white.png" alt="" />
  </div>
  <p>پکیج {{ title }} با موفقیت اضافه شد.</p>
  <span (click)="goMealPage()">برو به صفحه {{ title }}</span>
</div>
